module.exports = __webpack_public_path__ + "od-plus-black/od-plus-black-8d6bc36e39f6f3083f0999703daa8786.svg";